import React from 'react';

import Link from '@buyside/components/presentation/Link/link';

import MessageBubbleIcon from '@buyside/svgs/message_bubble.svg';
import StarIcon from '@buyside/svgs/star.svg';

import { newMessageUrl, rankingUrl } from '@buyside/util/urlHelper';

import styles from '../rankingStyles.scss';

const RankingActions: React.FC<{ userId?: string; canMessage: boolean }> = ({
  userId,
  canMessage
}) => (
  <div data-testid="ranking-actions" className={styles.rankingLeftRow}>
    <div className={styles.actionsHeading}>Actions</div>
    {canMessage && (
      <div className={styles.actionButton}>
        {userId && (
          <Link to={newMessageUrl(userId)} target="_blank">
            <MessageBubbleIcon className={styles.actionIcon} />
            Say Congratulations
          </Link>
        )}
      </div>
    )}
    <div className={styles.actionButton}>
      <Link to={rankingUrl()}>
        <StarIcon className={styles.actionIcon} />
        View Rankings
      </Link>
    </div>
  </div>
);

export default RankingActions;
